import './page-layout.css';

export function PageLayout(props) {
    const className = props.class || "";

    return (
        <div className={`page-layout ${className}`}>
            {props.header}
            <section className="page-content">
                {props.children}
            </section>
            {props.footer}
        </div>
    );
}